import {
  BookkeepersManagementDeleteTaskDocumentDocument,
  BookkeepersManagementDeleteTaskDocumentMutation,
  BookkeepersManagementDeleteTaskDocumentMutationVariables,
  BookkeepersManagementTaskDocumentsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'

export type DeleteTaskDocumentPayload =
  BookkeepersManagementDeleteTaskDocumentMutation['bookkeepersManagementMutations']['deleteBookkeepersmanagementTaskTaskDocument']

export const useDeleteTaskDocument = () => {
  const isBookkeeperView = useBookkeeperView()
  const [deleteTaskDocument, { loading }] = useMutation(
    BookkeepersManagementDeleteTaskDocumentDocument,
    {
      context: {
        isBookkeeperView,
      },
      extractorFn: (data: BookkeepersManagementDeleteTaskDocumentMutation) =>
        data.bookkeepersManagementMutations.deleteBookkeepersmanagementTaskTaskDocument,
    }
  )

  const deleteDocument = (
    variables: BookkeepersManagementDeleteTaskDocumentMutationVariables,
    incidenceId: number
  ) => {
    return deleteTaskDocument({
      variables,
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: BookkeepersManagementTaskDocumentsDocument,
          variables: { incidenceId },
        },
      ],
    })
  }

  return {
    loading,
    deleteDocument,
  }
}
